import { DEFAULT_INERTIA_ENTRY, type InertiaEntry } from '@/lib/app-entry';
import i18n, { syncWithLaravelLocale } from '@/lib/i18n';
import type { i18n as I18nInstance } from 'i18next';
import type { ReactElement, ReactNode } from 'react';
import { createContext } from 'react';
import { I18nextProvider } from 'react-i18next';

export const InertiaEntryContext = createContext<InertiaEntry>(DEFAULT_INERTIA_ENTRY);

export function syncLocaleFromPageProps(props: { initialPage: { props: Record<string, unknown> } }): void {
    const locale = props.initialPage.props.locale as string | undefined;

    if (locale && i18n.language !== locale) {
        syncWithLaravelLocale(locale);
    }
}

export function InertiaAppProviders({
    children,
    i18nInstance = i18n,
    entry = DEFAULT_INERTIA_ENTRY,
}: {
    children: ReactNode;
    i18nInstance?: I18nInstance;
    entry?: InertiaEntry;
}): ReactElement {
    return (
        <InertiaEntryContext.Provider value={entry}>
            <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>
        </InertiaEntryContext.Provider>
    );
}
